<template>
  <v-card flat class="blueCard" :style="css ? css : defaultStyle">
    <v-card-title class="d-flex flex-row flex-wrap justify-center">
      <div class="d-flex flex-row align-center">
        <div style="width: 100px" v-if="image">
          <v-img :src="image" contain max-height="60" />
        </div>

        <div class="ml-3 mb-3">
          <div class="text-h5">{{ title }}</div>
          <div class="caption">
            {{ subtitle }}
          </div>
        </div>
      </div>
      <v-spacer class="d-none d-sm-flex"></v-spacer>
      <div v-if="documentationPage" class="caption">
        <a :href="documentationPage">
          {{ docTitle }}
          <v-icon x-small color="primary" class="mx-1"
            >mdi-open-in-new</v-icon
          ></a
        >
      </div>
    </v-card-title>

    <slot></slot
  ></v-card>
</template>

<script>
// import Name from "../dir/file";

export default {
  name: "TitleHeader",
  props: {
    image: null,
    title: String,
    subtitle: String,
    documentationPage: String,
    documentationTitle: String,
    css: null,
  },
  data: function () {
    return {
      defaultStyle:
        "background-image: linear-gradient(349deg, #c0e5ff, #f5fbff);",
    };
  },
  methods: {},
  computed: {
    docTitle: function () {
      if (!this.documentationPage) return null;
      return this.documentationTitle
        ? this.documentationTitle
        : this.title + " Documentation";
    },
  },
};
</script>

<style scoped></style>
